// @flow
import styles from './ExpiredJob.less';

import React, { PureComponent } from 'react';
import NavLink from 'src/components/NavLink/NavLink';
import { PageBlock, Section, Card, Text, Button } from 'seek-style-guide/react';

export default class ExpiredJob extends PureComponent<*> {
  render() {
    return (
      <PageBlock data-automation="expiredJobPage" className={styles.root}>
        <Section header>
          <Text headline> This job is no longer advertised</Text>
        </Section>
        <Card>
          <Section>
            <Text>
              Jobs remain on SEEK for 30 days, unless the advertiser removes
              them sooner.
            </Text>
            <NavLink
              role="link"
              component={Button}
              color="pink"
              location="/"
              className={styles.searchAgain}
            >
              Search for another job
            </NavLink>
          </Section>
        </Card>
      </PageBlock>
    );
  }
}
